module.exports = __webpack_public_path__ + "img/defaultHead.1f33262c.png";